import { GridColDef } from '@mui/x-data-grid'
import { formatAbsenceHours, getPayApprovalHoursDisplayValue, getUnpaidHoursDisplayValue } from '../../utils/absence-utils'

function headerText(testId: string, headerName?: string) {
  return (
    <div style={{ fontWeight: 'bold', color: 'black' }} data-testid={testId}>
      {headerName}
    </div>
  )
}
const getColumnTestId = (columnName: string): string => `ManAuth-Chart-${columnName}`

const sicknessOnlyColumns = ['OSP']

export const getManAuthColumns = (isSickness: boolean) => {
  const columns: GridColDef[] = [
    {
      field: 'Date',
      headerName: 'Date',
      headerClassName: 'header',
      flex: 1,
      renderHeader: params => headerText(getColumnTestId(params.field), params.colDef.headerName),
      renderCell: params => (
        <div data-testid={`cell-name-${params.row.id}`}>
          {params.value ? new Date(params.value).toLocaleDateString(navigator.language) : 'N/A'}
        </div>
      ),
    },
    {
      field: 'OSP',
      headerName: 'OSP',
      headerClassName: 'header',
      flex: 1,
      renderHeader: params => headerText(getColumnTestId(params.field), params.colDef.headerName),
      renderCell: params => (
        <div data-testid={`cell-name-${params.row.id}`}>{formatAbsenceHours(params.value)}</div>
      ),
    },
    {
      field: 'payApproval',
      headerName: 'Discretionary Pay',
      headerClassName: 'header',
      flex: 1,
      renderHeader: params => headerText(getColumnTestId(params.field), params.colDef.headerName),
      renderCell: params => {
        const { requestStatus } = params.row
        return (
          <div data-testid={`cell-name-${params.row.id}`}>
            {getPayApprovalHoursDisplayValue(params.value, requestStatus)}
          </div>
        )
      },
    },
    {
      field: 'Unpaid',
      headerName: 'Unpaid',
      headerClassName: 'header',
      flex: 1,
      renderHeader: params => headerText(getColumnTestId(params.field), params.colDef.headerName),
      renderCell: params => (
        <div data-testid={`cell-name-${params.row.id}`}>
          {getUnpaidHoursDisplayValue(params.value, params.row.payApproval, params.row.requestStatus)}
        </div>
      ),
    },
  ]

  return isSickness ? columns : columns.filter(column => !sicknessOnlyColumns.includes(column.field))
}
